/* eslint-disable react/prop-types */
import React from 'react';
import { Upload } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Sub-Batch 3M (Niranjan, Feb 26 2026) — extracted from BreedingPipeline.js.
 * Pure visual extraction: zero behavioural change.  Original JSX block was
 * lines ~252-305 of BreedingPipeline.js.  Props mirror the local state
 * variables and callbacks from the parent.
 */
export const PipelineUploadZone = ({
  file,
  setFile,
  fileRef,
  depVarOverride,
  setDepVarOverride,
  handleDrop,
}) => (
  <div className="space-y-3">
    <div
      className="rounded-xl text-center cursor-pointer transition-all"
      style={{
        border: '2px dashed #CBD5E0',
        padding: 32,
        background: '#FAFAFA',
        borderRadius: 'var(--radius-lg)',
      }}
      onClick={() => fileRef.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        e.currentTarget.style.borderColor = '#1B4332';
      }}
      onDragLeave={(e) => {
        e.currentTarget.style.borderColor = '#CBD5E0';
      }}
      onDrop={handleDrop}
      data-testid="pipeline-upload-zone"
    >
      <input
        ref={fileRef}
        type="file"
        className="hidden"
        accept=".csv,.xlsx,.xls"
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) {
            setFile(f);
            toast.success(`${f.name} loaded`);
          }
        }}
      />
      <Upload size={24} className="mx-auto mb-2" style={{ color: '#A0AEC0' }} />
      <p className="font-body text-sm" style={{ color: 'var(--text-medium)' }}>
        {file ? (
          <span style={{ color: 'var(--green-700)', fontWeight: 600 }}>{file.name}</span>
        ) : (
          'Drop RBD/CRD data (CSV/Excel) with multiple traits'
        )}
      </p>
      <p className="font-body text-xs mt-1" style={{ color: 'var(--text-light)' }}>
        Required: Treatment, Block, Yield, Trait2, Trait3...
      </p>
    </div>

    {file && (
      <div className="flex items-center gap-2">
        <label
          className="font-body text-xs font-semibold"
          style={{ color: 'var(--text-dark)' }}
        >
          Yield column (optional):
        </label>
        <input
          type="text"
          value={depVarOverride}
          onChange={(e) => setDepVarOverride(e.target.value)}
          placeholder="Auto-detect (Yield)"
          className="font-body text-xs px-2 py-1.5 rounded-md border"
          style={{ borderColor: 'var(--border-color)', width: 180 }}
          data-testid="pipeline-dep-var"
        />
      </div>
    )}
  </div>
);

export default PipelineUploadZone;
